module.exports = __webpack_public_path__ + "static/img/img_wei_002.4d65317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_wei_002.png
// module id = kXH0
// module chunks = 2